<script>
/* eslint-disable vue/no-unused-properties */
import { mapGetters } from 'vuex';
// import { PropagateLoader } from '@saeris/vue-spinners';
import { dialogPresets } from '@/services/dialogPresets';
import { licenseErrorCode } from '@/const/licensePage';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { CommonDataDocument, License_Action_Activate_AsyncDocument, License_Action_Refresh_AsyncDocument } from '@/graphql/codegen/generated/graphql';
import { longPolling } from '@/services/PlatfromGQL/longPolling';

export default {
  components: {
    // PropagateLoader,
  },

  mixins: [dialogPresets],
  data() {
    return {
      licenseKey: '',
      supportMailUrl: process.env.VUE_APP_SUPPORT_MAIL,
      licenseFailed: false,
      licenseFailedMessage: '',
      licenseFailedCount: 0,
      licenseRetryCount: 0,
      licensePending: false,
      timeoutHandle: undefined,
    };
  },

  computed: {
    ...mapGetters({
      accessToken: ['session/getAccessToken'],
    }),
    isFormDisabled() {
      return !this.isLicenseKeyValid;
    },
    isLicenseKeyValid() {
      return this.licensePending || (this.licenseKey && this.licenseKey.length > 0);
    },
    getIsLicenseValidWarning() {
      if (this.licenseFailed) {
        if (this.licenseFailedMessage.includes('expired')) return this.$t('login.licenseForm.licenseInput.validationBadLicenseExpired');
        if (this.licenseFailedMessage.includes('Could not connect')) return this.$t('login.licenseForm.licenseInput.validationBadLicenseNetworkFailed');
        return this.$t('login.licenseForm.licenseInput.validationBadLicense');
      }
      return this.isLicenseKeyValid;
    },
  },
  watch: {
    licenseFailed() {
      const input = this.$refs['license-key-field'];
      if (input) {
        this.$refs['license-key-field'].validate();
      }
    },
    licensePending() {
      const input = this.$refs['license-key-field'];
      if (input) {
        input.focus();
        input.resetValidation();
      }
    },
  },
  unmounted() {
    clearTimeout(this.timeoutHandle);
  },
  mounted() {
    this.$eventHub.$emit('closeLeftDrawer');
  },
  methods: {
    async submitLicense() {
      try {
        const enteredLicenseKey = this.licenseKey;
        if (!this.isLicenseKeyValid) return;
        this.$emit('loading', true);
        this.licenseFailed = false;
        this.licenseFailedMessage = '';
        const activatePollingId = await apolloClient.mutate({
          mutation: License_Action_Activate_AsyncDocument,
          variables: {
            licenseKey: enteredLicenseKey,
          },
        });
        const results = await longPolling.fetch('license_action_asyncResult', activatePollingId?.data?.license_action_activate_async);
        if (results?.data?.license_action_asyncResult?.result?.errorCode !== licenseErrorCode.No_Error) {
          this.dialogPresets.handleLicenseActivationErrorDialogs(this.openDialog, results?.data?.license_action_asyncResult?.result);
        } else {
          // refresh common data to get the new license state for the navigation guards
          await apolloClient.query({
            query: CommonDataDocument,
            variables: {
              coordinatorId: this._.appContext.config.globalProperties.coordinatorService.selectedCoordinator.value,
            },
            fetchPolicy: 'network-only',
          });
          await this.$router.push({ name: 'Home' });
          if (results?.data?.license_action_asyncResult?.result?.errorCode !== licenseErrorCode.No_Error || results?.data?.license_action_asyncResult?.result?.state === 5) {
            this.$store.commit('settings/setEnteredLicenseKeyValue', enteredLicenseKey);
            if (results?.data?.license_action_asyncResult?.result?.errorCode !== licenseErrorCode.No_Error) {
              this.licenseFailed = true;
              this.licenseFailedMessage = results?.data?.license_action_asyncResult?.message;
              this.licenseFailedCount += 1;
            }
          }
          this.dialogPresets.handleLicenseStateInfo(this.openDialog, results?.data?.license_action_asyncResult?.result);
        }
      } catch (error) {
        this.licenseFailed = true;
        this.licenseFailedMessage = '';
        this.licenseFailedCount += 1;
      } finally {
        this.$emit('loading', false);
      }
    },
    setLicenseValidChecked(event) {
      if (!/^[A-Za-z0-9-]+$/.test(event.key)) {
        event.preventDefault();
      }
      this.licenseFailed = false;
    },
    async refreshLicense() {
      try {
        this.licensePending = true;
        const refreshPollingId = await apolloClient.mutate({
          mutation: License_Action_Refresh_AsyncDocument,
        });
        const results = await longPolling.fetch('license_action_asyncResult', refreshPollingId?.data?.license_action_refresh_async);
        this.timeoutHandle = setTimeout(() => {
          this.licensePending = false;
          if (!results?.state) {
            this.licenseRetryCount += 1;
          }
        }, 2000);
      } catch (error) {
        this.licensePending = false;
      }
    },
  },
};
</script>
